<template>
  <v-card class="pa-4">
    <p class="title mb-1">{{ $t('campanhas.produtos') }}</p>

    <p class="primary-text">{{ $t('campanhas.produtos_fazem_parte_campanha') }}</p>

    <div class="d-flex align-center">
      <tooltip fit-content align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
        <modal-graphql-search-content
          button-activator
          button-text="Escolher produtos"
          :selected-items.sync="productsLocal"
          :is-industry-campaign="isIndustryCampaign"
          :disabled="isOfferSchedule || disabled"
        />
      </tooltip>
      <mf-button
        v-if="productsLocal.length > 0"
        label="Desvincular"
        color="vermelho-0"
        class="ml-2"
        outlined
        :disabled="isOfferSchedule || disabled"
        @click="removeAllProducts"
      />
    </div>

    <mf-tooltip top max-width="200px" :disabled="!isIndustryCampaign">
      <template v-slot:activator="{ on }">
        <v-row no-gutters>
          <v-col class="px-0 mt-3">
            <v-chip-group :column="showAllProducts" show-arrows active-class="primary--text">
              <v-chip
                v-for="(produto, index) in productsLocal"
                :key="index"
                small
                close
                :disabled="isIndustryCampaign || (showOfferScheduleWarning && isOfferSchedule) || disabled"
                @click:close="remove(index)"
              >
                <span>{{ produto.sku }} - {{ produto.name }}</span>
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </template>
      <span>{{ tooltipMessage }}</span>
    </mf-tooltip>

    <products-list-dialog :products="productsLocal" />

    <mf-info-card
      v-if="showOfferScheduleWarning && isOfferSchedule"
      class="mt-5"
      description="O botão de adição de produtos está bloqueado devido à campanha ativa na Gestão de Ofertas. Para desbloquear, desvincule a campanha primeiro."
      icon="warning"
      variant="warning"
    />
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
  components: {
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
    ProductsListDialog: () => import('@/components/ProductsListDialog.vue'),
  },
  props: {
    products: Array,
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    isOfferSchedule: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showOfferScheduleWarning: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showAllProducts: false,
  }),
  computed: {
    productsLocal: {
      get() {
        return this.products
      },
      set(value) {
        this.$emit('update:products', value)
      },
    },
  },
  methods: {
    remove(index) {
      const products = cloneDeep(this.productsLocal)
      products.splice(index, 1)
      this.productsLocal = products
    },
    removeAllProducts() {
      this.productsLocal = []
    },
  },
}
</script>
